module.exports = __webpack_public_path__ + "img/vipon-loading-white.75c91c7f.svg";